export enum Direction {
	UP = 'UP',
	DOWN = 'DOWN',
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
}

export enum Size {
	INLINE = 'INLINE',
	// Below are used by the API
	TINY = 'xs',
	SMALL = 's',
	MEDIUM = 'm',
	LARGE = 'l',
	EXTRA_LARGE = 'xl',
}

export enum Spacing {
	NONE = 'none',
	TIGHT = 'tight',
	REGULAR = 'regular',
	WIDE = 'wide',
	LOOSE = 'loose',
	EXTRA_LOOSE = 'extra-loose',
}
